import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { 
  User, 
  Bell, 
  Menu, 
  X, 
  Home, 
  FileText, 
  ShoppingBag, 
  Handshake,
  Leaf,
  UtensilsCrossed,
  LogIn,
  LogOut,
  Eye
} from 'lucide-react'
import Login from '../Login'
import Logout from '../Logout'
import { host } from '../script/variables'
import Notification from './Notification'
import '../style/Nav.css'
import { FcAbout } from 'react-icons/fc'

const Nav = ({ isLogin, setIsLogin, vegMode }) => {
  const [notification, setNotification] = useState([])
  const [pno, setpno] = useState(1)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isNotificationOpen, setIsNotificationOpen] = useState(false)

  function timeAgo(timestamp) {
    const currentTime = new Date();
    const previousTime = new Date(timestamp);
    const timeDifference = currentTime - previousTime;
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);

    if (months > 0) {
      return months === 1 ? '1 month' : months + ' months';
    } else if (weeks > 0) {
      return weeks === 1 ? '1 week' : weeks + ' weeks';
    } else if (days > 0) {
      return days === 1 ? '1 day' : days + ' days';
    } else if (hours > 0) {
      return hours === 1 ? '1 hour' : hours + ' hours';
    } else if (minutes > 0) {
      return minutes === 1 ? '1 minute' : minutes + ' minutes';
    } else {
      return seconds <= 5 ? 'just now' : seconds + ' seconds';
    }
  }

  const fetchNotification = async (pno) => {
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${host}/masala/notification?pno=${pno}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`
        }
      });
      
      if (response.ok) {
        setpno(pno + 1)
        const data = await response.json();
        setNotification(data)
      }
    } catch (error) {
      console.log('error in fetching notification')
    }
  }

  const openNotification = async () => {
    setIsNotificationOpen(!isNotificationOpen)
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${host}/masala/rnotifications`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`
        }
      });
      
      if (response.ok) {
        console.log('notifications removed')
      }
    } catch (error) {
      console.log('there is an error in removing notification')
    }
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  useEffect(() => {
    if (isLogin) {
      fetchNotification(pno)
    }
  }, [isLogin])

const navLinks = [
  { to: '/', icon: Home, label: 'Home', hideOnMobile: true },
  // { to: '/blog', icon: FileText, label: 'Blogs', hideOnMobile: true },
  { to: '/myOrders', icon: ShoppingBag, label: 'Orders',hideOnMobile: true },
  // { to: '/partner', icon: Handshake, label: 'Partner', hideOnMobile: true },
  { to: '/about', icon: Eye, label: 'Vision', hideOnMobile: true }
]

  return (
    <>
      <nav className={`modern-nav ${vegMode ? 'veg-mode' : ''}`}>
        <div className="nav-container">
          {/* Logo/Brand */}
          <div className="nav-brand">
            <Link to="/" className="brand-link">
              <div className="brand-icon">
                {/* {vegMode ? <Leaf size={20} /> : <UtensilsCrossed size={20} />}
                 */}

                
  <img
    src="/production_logo/RestroPilots_Monogram_Logomark.svg"
    alt="RestroPilots"
    width={20}
    height={20}
  />

              </div>
              <div className="brand-text-group">
                <span className="brand-text">Restropilots</span>
                <span className="brand-subtext">Food Finder</span>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="nav-links desktop-nav">
            {navLinks.map((link) => (
              <Link 
                key={link.to}
                to={link.to} 
                className="nav-link"
                onClick={closeMobileMenu}
              >
                <link.icon size={18} />
                <span>{link.label}</span>
              </Link>
            ))}
          </div>

          {/* User Actions */}
          <div className="nav-actions">
            {isLogin ? (
              <>
                {/* Profile — desktop only */}
                <Link to="/myprofile" className="nav-action-btn profile-btn desktop-only">
                  <User size={20} />
                  <span className="tooltip">Profile</span>
                </Link>

                {/* Notifications */}
                <div className="notification-wrapper">
                  <button 
                    className={`nav-action-btn notification-btn ${notification.length > 0 ? 'has-notifications' : ''}`}
                    onClick={openNotification}
                  >
                    <Bell size={20} />
                    {notification.length > 0 && (
                      <span className="notification-badge">{notification.length}</span>
                    )}
                    <span className="tooltip">Notifications</span>
                  </button>

                  {isNotificationOpen && (
                    <>
                      <div className="notification-overlay" onClick={() => setIsNotificationOpen(false)}></div>
                      <div className="notification-dropdown">
                        <div className="notification-content">
                          <Notification isLogin={isLogin} setIsLogin={setIsLogin} />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Logout — desktop only */}
                <div className="auth-action desktop-only">
                  <Logout setIsLogin={setIsLogin} />
                </div>
              </>
            ) : (
              /* Login — desktop only */
              <div className="auth-action desktop-only">
                <Login setIsLogin={setIsLogin} />
              </div>
            )}

            {/* Mobile Menu Toggle */}
            <button 
              className="mobile-menu-toggle"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
  <div className="mobile-nav-content">
    {navLinks
      .filter((link) => !link.hideOnMobile)
      .map((link) => (
        <Link 
          key={link.to}
          to={link.to} 
          className="mobile-nav-link"
          onClick={closeMobileMenu}
        >
          <link.icon size={20} />
          <span>{link.label}</span>
        </Link>
      ))}

    {/* Divider before auth section */}
    <div className="mobile-nav-divider" />

            {isLogin ? (
              <>
                {/* Profile link in mobile menu */}
                <Link
                  to="/myprofile"
                  className="mobile-nav-link"
                  onClick={closeMobileMenu}
                >
                  <User size={20} />
                  <span>My Profile</span>
                </Link>

                {/* Logout inside mobile menu */}
                <div className="mobile-auth-action">
                  <LogOut size={20} className="mobile-auth-icon" />
                  <Logout setIsLogin={setIsLogin} />
                </div>
              </>
            ) : (
              /* Login inside mobile menu */
              <div className="mobile-auth-action">
                <LogIn size={20} className="mobile-auth-icon" />
                <Login setIsLogin={setIsLogin} />
              </div>
            )}
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        {isMobileMenuOpen && (
          <div className="mobile-overlay" onClick={closeMobileMenu}></div>
        )}
      </nav>

      {/* Veg Mode Indicator */}
      {vegMode && (
        <div className="veg-mode-indicator">
          <Leaf size={16} />
          <span>Vegetarian Mode Active</span>
        </div>
      )}
    </>
  )
}

export default Nav